import { debug } from 'debug';
import { companyUUID } from '@/service/api';

const log = debug('cartsee:shoplazza');

declare global {
  interface Window {
    SHOPLAZZA?: {
      routes?: {
        root?: string;
      };
    };
  }
}

export function isInShoplazzaEditor() {
  // 方法 1: 检查 URL 中是否包含编辑器特定参数
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('preview_theme_id')) {
    return true;
  }

  // 方法 2: 检查父窗口是否存在且包含编辑器域名
  try {
    if (window.parent && window.parent !== window) {
      const parentHost = window.parent.location.host;
      if (parentHost.includes('myshoplaza.com/admin')) {
        return true;
      }
    }
  } catch (e) {
    // 如果出现跨域错误，忽略
  }

  // 如果以上条件都不满足，则认为是普通用户访问
  return false;
}


export function getCountryCode() {
  const countryCodeMap = {
    'm734e6ox': 'us',
    'm74lfs3i': 'sg'
  };
  if (['m734e6ox', 'm74lfs3i'].includes(companyUUID) && countryCodeMap[companyUUID]) {
    return '/' + countryCodeMap[companyUUID];
  }
  if (window?.SHOPLAZZA?.routes?.root) {
    log('window.SHOPLAZZA.routes.root=%s, CountryCode=%s', window.SHOPLAZZA.routes.root, window.SHOPLAZZA.routes.root.replace(/\/$/, ''));
    return window.SHOPLAZZA.routes.root.replace(/\/$/, '');
  }
  return '';
}

export * from '@/utils/shoplazza/newsletter';